import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import Papa from 'papaparse';
import moment from 'moment';

const getNestedValue = (obj, path) => {
  const value = path?.split('.')?.reduce((acc, key) =>
    (acc && acc[key] !== undefined ? acc[key] : undefined), obj);
  return path === "name" && !value ? "--" : (value !== undefined ? value : "");
};

export const handleCSVDownload = async ({ data, columns, fileNamePrefix = "Report", }) => {
  try {
    const csvData = data?.map((row, index) =>
      Object.fromEntries(columns?.map((col) =>
        col.key === "serialNumber"
          ? [col.label, index + 1]
          : col.label === "Pickup Date" || col.label === "End Date"
            ? [col.label, moment(row[col.key]).format("DD-MM-YYYY")]
            : col.label === "Pickup time" || col.label === "End time"
              ? [col.label, moment(row[col.key]).format("hh:mm:ss A")]
              : [col.label, getNestedValue(row, col.key)]
      ))
    );

    // const totalAmount = data?.reduce((acc, item) => acc + (item?.amount ?? 0), 0);
    // const dateRow = {
    //   [columns[0].label]: "Date",
    //   [columns[1].label]: `${fromDate ? fromDate : "--"} to ${toDate ? toDate : "--"}`,
    //   [columns[2].label]: "Total Amount",
    //   [columns[3].label]: totalAmount
    // };
    // const noteRow = {
    //   [columns[0].label]: "This is a System Generated Report and does not require any signature or stamp."
    // };

    // csvData?.push({}, {}, dateRow, noteRow);
    // csvData?.push({}, {}, dateRow, noteRow);

    const csv = Papa.unparse(csvData);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, `${fileNamePrefix}_${moment().format('DD-MM-YYYY')}.csv`);
  } catch (error) {
    console.error("Error downloading CSV:", error);
  }
};

export const handleExcelDownload = async ({ data, columns, fileNamePrefix = "Report",  }) => {
  try {
    const mainData = data?.map((row, index) =>
      Object.fromEntries(columns?.map((col) =>
        col.key === "serialNumber"
          ? [col.label, index + 1]
          : col.label === "Pickup Date" || col.label === "End Date"
            ? [col.label, moment(row[col.key]).format("DD-MM-YYYY")]
            : col.label === "Pickup time" || col.label === "End time"
              ? [col.label, moment(row[col.key]).format("hh:mm:ss A")]
              : [col.label, getNestedValue(row, col.key)]
      ))
    );

    // const totalAmount = data?.reduce((acc, item) => acc + (item?.amount ?? 0), 0);
    // const dateRow = {
    //   [columns[0].label]: "Date",
    //   [columns[1].label]: `${fromDate ? fromDate : "--"} to ${toDate ? toDate : "--"}`,
    //   [columns[2].label]: "Total Amount",
    //   [columns[3].label]: totalAmount
    // };
    // const noteRow = {
    //   [columns[0].label]: "This is a System Generated Report and does not require any signature or stamp."
    // };

    // const worksheetDataArray = [...mainData, {}, {}, dateRow, noteRow];
    const worksheetDataArray = [...mainData];
    const worksheet = XLSX.utils.json_to_sheet(worksheetDataArray);
    const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(blob, `${fileNamePrefix}_${moment().format('DD-MM-YYYY')}.xlsx`);
  } catch (error) {
    console.error("Error downloading Excel:", error);
  }
};

export const handlePDFDownload = async ({ data, columns, fileNamePrefix = "Report" }) => {
  try {
    const doc = new jsPDF({
      orientation: "p",
      unit: "pt",
      format: "a3",
      putOnlyUsedFonts: true,
    });

    const tableColumn = columns?.map((col) => col.label);
    const tableRows = data?.map((row, index) =>
      columns?.map((col) => {
        if (col.key === "serialNumber") return String(index + 1);
        const value =
          col.label === "Pickup Date" || col.label === "End Date"
            ? moment(row[col.key]).format("DD-MM-YYYY")
            : col.label === "Pickup time" || col.label === "End time"
              ? moment(row[col.key]).format("hh:mm:ss A")
              : getNestedValue(row, col.key);
        return String(value || "");
      })
    );

    // const totalAmount = data?.reduce((acc, item) => acc + (item?.amount ?? 0), 0);
    // const dateRow = columns?.map((col, index) => {
    //   if (index === 0) return "Date";
    //   if (index === 1) return `${fromDate ? fromDate : "--"} to ${toDate ? toDate : "--"}`;
    //   if (index === 2) return "Total Amount";
    //   if (index === 3) return String(totalAmount);
    //   return "";
    // });
    // const noteRow = [{
    //   content: "This is a System Generated Report and does not require any signature or stamp.",
    //   colSpan: columns.length,
    //   styles: { halign: "center", fontStyle: "italic", fontSize: 10 }
    // }];

    // tableRows?.push({}, {}, dateRow, noteRow);

    doc.autoTable({
      startY: 40,
      head: [tableColumn],
      body: tableRows,
      styles: {
        fontSize: 10,
        cellPadding: 4,
        halign: 'center',
        valign: 'middle'
      },
      columnStyles: columns?.reduce(
        (acc, _, index) => ({
          ...acc,
          [index]: { cellWidth: "auto", minCellHeight: 20 },
        }),
        {}
      ),
      headStyles: {
        fillColor: [220, 220, 220],
        textColor: 20,
        fontSize: 11,
        font: "helvetica",
        lineWidth: 0.5,
        lineColor: [0, 0, 0],
        halign: 'center',
        valign: 'middle',
      },
      bodyStyles: {
        lineWidth: 0.5,
        lineColor: [0, 0, 0],
        halign: 'center',
        valign: 'middle'
      },
    });

    const fileName = `${fileNamePrefix}_${moment().format("DD-MM-YYYY")}.pdf`;
    doc.save(fileName);
  } catch (error) {
    console.error("Error downloading PDF:", error);
  }
};